import { useContext } from 'react';
import { ModalContext } from '../../context/ModalContext';
import type { TypedOpenModal } from './modalRegistry';

export const useModal = () => {
  const { state, openModal: rawOpen, closeModal } = useContext(ModalContext);
  const openModal = rawOpen as unknown as TypedOpenModal;
  return { openModal, closeModal, isOpen: state.isOpen };
};
